import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Form, Table } from "react-bootstrap";
import ListGroup from 'react-bootstrap/ListGroup';
import getAPI from '../../service/getAPI';
import TableLoader from '../widgets/TableLoader';
import ViewDetailsModal from '../widgets/ViewDetailsModal';

const Courier = () => {

    const { master } = getAPI();
    const [list, setList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalBody, setModalBody] = useState("");
    const [filteredList, setFilteredList] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    // const [trackOnly, setTrackOnly] = useState(false);
    const [deliveryStatus, setDeliveryStatus] = useState("")
    const [globalSearch, setGlobalSearch] = useState("")
    const [statusOptions, setStatusOptions] = useState([]);

    const [filters, setFilters] = useState({
        order_code: "",
        order_date: "",
        customer_name: "",
        shipping_courier: "",
        tracking_number: "",
        channel: "",
        phone_number: "",
        courier_status: "",
        // product: "",
        // address: "",
        // state: "",
        // pincode: "",
    });

    const [dateFilter, setDateFilter] = useState({
        fromDate: "",
        toDate: "",
    });

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;

    // eslint-disable-next-line 
    useEffect(() => {
        loadData();
    }, []);


    // eslint-disable-next-line
    useEffect(() => {
        if (globalSearch.trim()) {
            const filteredData = [...list].filter(item =>
                Object.values(item).some(val =>
                    String(val).toLowerCase().includes(globalSearch.toLowerCase().trim())
                )
            );
            setFilteredList(filteredData);
            setCurrentPage(1);
        } else {
            applyFilters([...filteredList])
        }
    }, [globalSearch]);

    // eslint-disable-next-line
    useEffect(() => {
        if (deliveryStatus === "") {
            setFilteredList([...list]);
        } else {
            setFilteredList([...list].filter(order => order?.courier_status === deliveryStatus));
        }
    }, [deliveryStatus, list]);


    useEffect(() => {
        const fetchStatusOptions = async () => {
            try {
                const response = await axios.post(master.getCourierStatus); // replace with actual endpoint
                if (response.data?.flag === 1 && Array.isArray(response.data.data)) {
                    setStatusOptions(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching status options:', error);
            }
        };
        fetchStatusOptions();
    }, []);

    // const loadData = async (filterData = {}) => {
    //     setIsLoading(true);
    //     try {
    //         let body = {};
    //         if (filterData) {
    //             body = {
    //                 fromDate: filterData?.fromDate,
    //                 toDate: filterData?.toDate,
    //             }
    //         }
    //         let res = await axios.post(master.unicommerce_order_list, body);
    //         res.data.data = [...res.data.data]?.filter(
    //             item => item.tracking_number && item.tracking_number.trim() !== ""
    //         );
    //         res.data.data = [...res.data.data]?.sort((a, b) => new Date(b.order_date) - new Date(a.order_date));
    //         res.data.data = [...res.data.data]?.filter(order => order?.channel === 'CUSTOM' || order?.channel === 'OS_CUSTOM' || order?.channel === 'SHOPIFY')
    //         res.data.data = [...res.data.data]?.map(order => {
    //             const deliveredSet = new Set(["COMPLETE", "RECIVED", "DELIVERED"]);
    //             // const undeliveredSet = new Set(["PROCESSING", "TRANSIT"]);

    //             if (deliveredSet.has(order.courier_status)) {
    //                 return { ...order, courier_status: "DELIVERED" };
    //             } else {
    //                 return { ...order, courier_status: "UNDELIVERED" };
    //             }
    //         });

    //         setList(res.data.data);
    //         setFilteredList(res.data.data);
    //         setCurrentPage(1);
    //     } catch (err) {
    //         console.error(err);
    //     }
    //     setIsLoading(false);
    // };

    const loadData = async (filterData = {}) => {
        setIsLoading(true);
        try {
            let body = {};
            // Include filters directly from filterData
            if (filterData) {
                body = {
                    fromDate: filterData?.fromDate,
                    toDate: filterData?.toDate,
                    courier_status: filterData?.courier_status || undefined, // directly use raw API value
                };
            }

            let res = await axios.post(master.unicommerce_order_list, body);

            // Filter out entries with empty tracking numbers
            let data = res.data.data?.filter(
                item => item.tracking_number && item.tracking_number.trim() !== ""
            );

            // Sort by date
            data = data?.sort((a, b) => new Date(b.order_date) - new Date(a.order_date));

            // Filter by allowed channels
            data = data?.filter(order =>
                ['CUSTOM', 'OS_CUSTOM', 'SHOPIFY'].includes(order.channel)
            );

            // ❌ Don't normalize courier_status (leave it as-is from the API)

            setList(data);
            setFilteredList(data);
            setCurrentPage(1);
        } catch (err) {
            console.error(err);
        }
        setIsLoading(false);
    };

    const downloadCSV = () => {
        const headers = Object.keys(Object.keys(filters)[0]).join(",") + "\n";
        let newList = JSON.parse(JSON.stringify([...list]));
        if (selectedRows.length > 0) {
            newList = [...newList].filter(item => selectedRows.includes(item.order_code));
        }
        for (let item of newList) {
            if (item?.courier_status !== "DELIVERED") {
                item.courier_status = "UNDELIVERED"
            }
        }
        const rows = [
            Object.keys(filters).join(","), // header row
            ...newList.map(row =>
                Object.keys(filters).map(key => row[key] ?? "").join(",")
            )
        ].join("\n");

        const csvContent = headers + rows;
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `data_${new Date().toISOString()}.csv`;
        link.click();

        URL.revokeObjectURL(url);
    }

    // const handleFilterChange = (e) => {
    //     const { name, value } = e.target;
    //     setFilters({ ...filters, [name]: value });
    //     setFilteredList(applyFilters(list));
    //     setCurrentPage(1); // Reset pagination to first page after applying filter
    // };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const applyFilters = (data) => {
        let filteredData = data;

        // ✅ Filter by Date Range (From - To)
        // if (dateFilter.fromDate && dateFilter.toDate) {
        //     const fromDate = new Date(dateFilter.fromDate);
        //     const toDate = new Date(dateFilter.toDate);

        //     filteredData = filteredData.filter((item) => {
        //         if (!item.order_date) return false;

        //         const orderDate = new Date(item.order_date);
        //         if (isNaN(orderDate)) return false;

        //         return orderDate >= fromDate && orderDate <= toDate;
        //     });
        // }

        // ✅ Tracking Number only filter
        // if (trackOnly) {
        //     filteredData = filteredData.filter(
        //         (item) =>
        //             item.tracking_number && item.tracking_number.toString().trim() !== ""
        //     );
        // }

        // ✅ Text filters (like order_code, customer_name, etc.)
        // Object.keys(filters).forEach((key) => {
        //     const filterValue = filters[key].trim().toLowerCase();
        //     if (!filterValue) return;

        //     filteredData = filteredData.filter((item) => {
        //         const itemValue = item[key];

        //         if (itemValue === null || itemValue === undefined) return false;

        //         // Special case for order_date — compare DD/MM/YYYY format
        //         if (key === "order_date") {
        //             const formattedDate = new Date(itemValue).toLocaleDateString("en-IN"); // 'dd/mm/yyyy'
        //             return formattedDate.includes(filterValue);
        //         }

        //         return itemValue.toString().toLowerCase().includes(filterValue);
        //     });
        // });


        // if (deliveryStatus) {
        //     filteredData = [...filteredData].filter(
        //         order => order?.courier_status?.toLowerCase() === deliveryStatus.toLowerCase()
        //     );
        // }
        // if (deliveryStatus) {
        //     filteredData = [...filteredData].filter(order => order?.courier_status === deliveryStatus);
        // }

        // return filteredData;

        Object.keys(filters).forEach((key) => {
            const filterValue = filters[key].trim().toLowerCase();
            if (!filterValue) return;

            filteredData = filteredData.filter((item) => {
                const itemValue = item[key];

                if (itemValue === null || itemValue === undefined) return false;

                // Special case for order_date — compare DD/MM/YYYY format
                if (key === "order_date") {
                    const formattedDate = new Date(itemValue).toLocaleDateString("en-IN"); // 'dd/mm/yyyy'
                    return formattedDate.includes(filterValue);
                }

                // ✅ Special case for courier_status — use exact match (case-insensitive)
                if (key === "courier_status") {
                    return itemValue.toLowerCase().trim() === filterValue;
                }

                return itemValue.toString().toLowerCase().includes(filterValue);
            });
        });

        return filteredData;

    };

    // useEffect(() => {
    //     // eslint-disable-next-line
    //     setFilteredList(applyFilters(list));
    // }, [filters, list]);

    useEffect(() => {
        setFilteredList(applyFilters(list));
    }, [filters, list, deliveryStatus]);

    const handleCheckboxChange = (id) => {
        setSelectedRows((prev) =>
            prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
        );
    };

    const handleSelectAll = () => {
        if (selectedRows.length === currentItems.length) {
            setSelectedRows([]);
        } else {
            setSelectedRows(currentItems.map((item) => item.order_code));
        }
    };

    const handleReset = () => {
        setFilters({
            order_date: "",
            customer_name: "",
            shipping_courier: "",
            tracking_number: "",
            channel: "",
            phone_number: "",
            courier_status: "",
        });
        setDateFilter({ fromDate: "", toDate: "" });
        loadData();
    };

    const handleModalData = (order) => {
        let status = order?.courier_status.toUpperCase() || "N/A";
        let trackingData = "";
        let trackingUrl = order?.tracking_url;
        if (order?.tracking_array) {
            let trackingJson = []
            try {
                trackingJson = JSON.parse(order?.tracking_array);
                trackingJson?.sort((a, b) => new Date(b.date) - new Date(a.date));
                if (trackingJson.length > 0) {
                    trackingData =
                        <ListGroup className='mb-3'>
                            {
                                trackingJson?.map(row => <div className='row'>
                                    <ListGroup.Item>
                                        <span className='badge text-bg-light'>{new Date(row?.date).toLocaleDateString("en-IN")} {new Date(row?.date).toLocaleTimeString()}</span> <br />
                                        <span className='ms-2'><strong>Location:</strong> {row?.location}</span> <br />
                                        <span className='ms-2'><strong>Activity:</strong> {row?.activity}</span> <br />
                                    </ListGroup.Item>
                                </div>)
                            }
                        </ListGroup>
                }

            } catch {
                console.log("Error in tracking JSON")
            }

        }
        let body = <>
            <p>
                <strong className='ms-2'>Status: </strong>
                <span className='text-primary'>{status}</span>
            </p>
            <p className='ms-2' >
                Customer Tracking URL: <a target='_blank' rel="noreferrer" href={`/track/${order?.tracking_number}`}>Click here</a>
            </p>
            <div>
                {trackingData}
            </div>
            {
                trackingUrl !== "" &&
                <>
                    <div className='text-center'>
                        <p>For more Information: <a target='_blank' rel="noreferrer" href={trackingUrl}> Click here</a> </p>
                    </div>
                </>
            }
        </>;

        setModalBody(body)
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredList.length / itemsPerPage);

    return (
        <main id="main" className="main">
            <div className="pagetitle">
                <h1>Courier Department</h1>
            </div>

            <div className="row mt-3">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body pt-3">
                            <div className="row mb-3">
                                <div className="col-md-2">
                                    <label>From Date:</label>
                                    <Form.Control
                                        type="date"
                                        value={dateFilter.fromDate}
                                        onChange={(e) =>
                                            setDateFilter({ ...dateFilter, fromDate: e.target.value })
                                        }
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label>To Date:</label>
                                    <Form.Control
                                        type="date"
                                        value={dateFilter.toDate}
                                        onChange={(e) =>
                                            setDateFilter({ ...dateFilter, toDate: e.target.value })
                                        }
                                    />
                                </div>
                                <div className="col-md-4 d-flex align-items-end">
                                    <Button
                                        variant="primary"
                                        onClick={() => loadData({ ...dateFilter })}
                                        className="me-2"
                                    >
                                        Submit
                                    </Button>
                                    <Button
                                        variant="secondary"
                                        onClick={handleReset}
                                        className="me-2"
                                    >
                                        Reset
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={downloadCSV}
                                        className="me-2"
                                    >
                                        CSV
                                    </Button>
                                </div>
                                <div className="col-md-4 d-flex align-items-end">
                                    <Form.Control
                                        id='global-search'
                                        type="text"
                                        placeholder="Search here"
                                        name=""
                                        value={globalSearch}
                                        onChange={e => setGlobalSearch(e.target.value)}
                                    />
                                </div>
                            </div>

                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr className="table-secondary">
                                        <th>
                                            <Form.Check
                                                type="checkbox"
                                                checked={
                                                    selectedRows.length === currentItems.length &&
                                                    currentItems.length > 0
                                                }
                                                onChange={handleSelectAll}
                                            />
                                        </th>
                                        <th>No.</th>
                                        {Object.keys(filters).map((key) => (
                                            <th key={key}>{key.replace("_", " ").toUpperCase()}</th>
                                        ))}
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        {Object.keys(filters).map((key) => (
                                            <th key={key}>
                                                {key === "tracking_number" ? (
                                                    <>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder={`Filter ${key.replace("_", " ")}`}
                                                            name={key}
                                                            value={filters[key]}
                                                            onChange={handleFilterChange}
                                                        />
                                                    </>
                                                ) : key === "courier_status" ? (<Form.Select
                                                    aria-label="Default select example"
                                                    value={filters[key]} // use filters[key] instead of deliveryStatus
                                                    onChange={e => handleFilterChange({ target: { name: key, value: e.target.value } })}
                                                >
                                                    <option value="">---select---</option>
                                                    {statusOptions.map((status, index) => (
                                                        <option key={index} value={status}>
                                                            {status}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                ) : (
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={`Filter ${key.replace("_", " ")}`}
                                                        name={key}
                                                        value={filters[key]}
                                                        onChange={handleFilterChange}
                                                    />
                                                )}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>

                                <tbody>
                                    {isLoading ? <tr>
                                        <td colSpan="12" className="text-center">
                                            <TableLoader />
                                        </td>
                                    </tr> : <>
                                        {currentItems.length > 0 ? (
                                            currentItems.map((unicommerce_detail, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={selectedRows.includes(
                                                                unicommerce_detail.order_code
                                                            )}
                                                            onChange={() =>
                                                                handleCheckboxChange(
                                                                    unicommerce_detail.order_code
                                                                )
                                                            }
                                                        />
                                                    </td>
                                                    <td>{indexOfFirstItem + index + 1}</td>
                                                    {/* {Object.keys(filters).map((key) => (
                                                        <td key={key}>
                                                            {key === "order_date" && unicommerce_detail[key]
                                                                ? new Date(
                                                                    unicommerce_detail[key]
                                                                ).toLocaleDateString("en-IN") // Or "en-US" as needed
                                                                : key === "courier_status" && unicommerce_detail[key] !== "DELIVERED" ?
                                                                    <p className='text-primary' role='button' onClick={() => { setShowModal(true); handleModalData(unicommerce_detail) }}>UNDELIVERED</p>
                                                                    : unicommerce_detail[key]}
                                                        </td>
                                                    ))} */}

                                                    {Object.keys(filters).map((key) => (
                                                        <td key={key}>
                                                            {key === "order_date" && unicommerce_detail[key] ? (
                                                                new Date(unicommerce_detail[key]).toLocaleDateString("en-IN")
                                                            ) : key === "courier_status" && unicommerce_detail[key] !== "DELIVERED" ? (
                                                                <p
                                                                    className="text-primary"
                                                                    role="button"
                                                                    onClick={() => {
                                                                        setShowModal(true);
                                                                        handleModalData(unicommerce_detail);
                                                                    }}
                                                                >
                                                                    {unicommerce_detail[key]}
                                                                </p>
                                                            ) : (
                                                                unicommerce_detail[key]
                                                            )}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))
                                        ) :
                                            (
                                                <tr>
                                                    <td colSpan="12" className="text-center">
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                    </>}
                                </tbody>
                            </Table>

                            <div className="card-footer d-flex justify-content-between align-items-center">
                                <div>
                                    Showing {indexOfFirstItem + 1} to{" "}
                                    {Math.min(indexOfLastItem, filteredList.length)} of{" "}
                                    {filteredList.length} entries
                                </div>
                                <nav aria-label="Page navigation">
                                    <ul className="pagination mb-0">
                                        <li
                                            className={`page-item ${currentPage === 1 ? "disabled" : ""
                                                }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(currentPage - 1)}
                                                disabled={currentPage === 1}
                                            >
                                                &laquo; Prev
                                            </button>
                                        </li>

                                        {/* Page Dropdown */}
                                        <li className="page-item">
                                            <Form.Select
                                                className="custom-pagination-dropdown"
                                                value={currentPage}
                                                onChange={(e) => setCurrentPage(Number(e.target.value))}
                                            >
                                                {Array.from({ length: totalPages }, (_, i) => (
                                                    <option key={i + 1} value={i + 1}>
                                                        Page {i + 1}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </li>

                                        <li
                                            className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                                }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                            >
                                                Next &raquo;
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                showModal ? (<ViewDetailsModal
                    title="Tracking Details"
                    body={modalBody}
                    show={showModal}
                    setShow={setShowModal}
                />) : (<></>)
            }
        </main>
    )
}

export default Courier
